// src/constants/constants.js


export const API_BASE_URL = window.location.hostname === 'localhost'
  ? "http://localhost:6111/api"
  : "/api";

//hai//


//new//